import { useEffect, useState } from "react";
import { getInitials } from "../../utils/generatefilename";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { patientPhotoUrl } from "../../config/practice";

const BENEFITS_LIST = [
  "Visit",
  "Labs",
  "EKG",
  "Ultrasound",
  "Sleep Study",
  "Echo",
  "Injection",
];

const BenefitsApprovalModal = ({
  isOpen,
  changestatus,
  onClose,
   onSave,
  colors,
  profile,
}) => {
  const [showBenefits, setShowBenefits] = useState(false);
  const [selectedBenefits, setSelectedBenefits] = useState([]);
  const userConfig = useSelector((state) => state.userconfig);
  useEffect(() => {
  if (!isOpen || !profile) {
    setShowBenefits(false);
    setSelectedBenefits([]);
    return;
  }

  setShowBenefits(false);
  setSelectedBenefits(profile?.ins_config?.benefits || []);
}, [isOpen, profile]);

  if (!isOpen) return null;

  const toggleBenefit = (benefit) => {
    setSelectedBenefits((prev) =>
      prev.includes(benefit)
        ? prev.filter((b) => b !== benefit)
        : [...prev, benefit]
    );
  };

  const handleAddBenefits = () => {
    if (!selectedBenefits.length) return;

    // 👉 You can replace this with API call
    console.log("Assigned benefits:", selectedBenefits);

     onSave({
      patientid: profile.patientid,
       "ins_status": "P",
       isexit:false,
      ins_config: {
     ...profile.ins_config,
        benefits: selectedBenefits,
         updatedby:userConfig?.username,
          updatedon: dayjs().toISOString(),
      },
    });
  };
const isReferencePresent =
  profile?.ins_config &&
  Object.prototype.hasOwnProperty.call(
    profile.ins_config,
    "referencenumber"
  ) &&
  String(profile.ins_config.referencenumber || "").trim() !== "";

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40">
      <div className="w-[360px] rounded-xl bg-white shadow-lg">

        {/* ---------------- HEADER ---------------- */}
        <div className="flex items-center justify-between rounded-t-xl bg-[#1E2B52] px-4 py-3">
          <div className="flex items-center gap-3">
          <div
  className="relative flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold text-[#1D2951] overflow-hidden"
  style={{
    backgroundColor: colors?.[profile?.ins_status] || "#9CA3AF",
  }}
>
  <img
    src={patientPhotoUrl(profile?.patientid)}
    alt={`${profile?.firstname} ${profile?.lastname}`}
    className="absolute inset-0 h-full w-full object-cover"
    onLoad={(e) => {
      // hide initials when image loads
      e.target.nextSibling.style.display = "none";
    }}
    onError={(e) => {
      // hide broken image, keep initials
      e.target.style.display = "none";
    }}
  />

  {/* Initials fallback */}
  <span className="relative z-10">
    {getInitials(profile?.firstname, profile?.lastname)}
  </span>
</div>


            <div>
              <p className="text-sm font-semibold text-white">
                {profile.firstname} {profile.lastname}
              </p>
              <p className="text-xs text-gray-300">
                {profile.insurance || "-"}
              </p>
            </div>
          </div>

          <button onClick={onClose} className="text-white text-lg">
            ×
          </button>
        </div>

        {/* ---------------- BODY ---------------- */}
        <div className="p-4 space-y-4">

          {!showBenefits ? (
            /* -------- EMPTY STATE -------- */
            <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-4 text-center">
              <p className="text-sm text-gray-500">
                No benefits assigned
              </p>

              <button
                onClick={() => setShowBenefits(true)}
                className="
                  mt-3 w-full rounded-md
                  border-[1.5px] border-[#50869A]
                  bg-white py-2 text-sm font-medium
                  text-[#50869A] hover:bg-blue-50
                "
              >
                Assign Benefits
              </button>
            </div>
          ) : (
            /* -------- BENEFITS SELECTION -------- */
            <div className="rounded-lg border border-gray-300 p-4 text-sm">
              <p className="mb-2 font-medium text-gray-700">
                Select Covered Benefits
              </p>

              <div className="space-y-2">
                {BENEFITS_LIST.map((b) => (
                  <label
                    key={b}
                    className="flex items-center gap-2"
                  >
                    <input
                      type="checkbox"
                      checked={selectedBenefits.includes(b)}
                      onChange={() => toggleBenefit(b)}
                    />
                    {b}
                  </label>
                ))}
              </div>

              <button
                onClick={handleAddBenefits}
                disabled={!selectedBenefits.length}
                className={`
                  mt-4 w-full rounded-md py-2
                  text-sm font-medium text-white
                  ${
                    selectedBenefits.length
                      ? "bg-[#50869A]"
                      : "bg-gray-300 cursor-not-allowed"
                  }
                `}
              >
                Add Benefits
              </button>
            </div>
          )}

          {/* -------- ACTION BUTTONS -------- */}
       {/* -------- ACTION BUTTONS -------- */}
<div className="flex gap-3">
  <button
    disabled={!isReferencePresent}
    onClick={() =>
      changestatus({
        patientid: profile.patientid,
        status: "A",
      })
    }
    className={`
      flex-1 rounded-lg py-2 text-sm font-medium text-white
      ${
        isReferencePresent
          ? "bg-[#50869A]"
          : "bg-gray-300 cursor-not-allowed"
      }
    `}
  >
    ✓ Approve
  </button>

  <button
    disabled={!isReferencePresent}
    onClick={() =>
      changestatus({
        patientid: profile.patientid,
        status: "R",
      })
    }
    className={`
      flex-1 rounded-lg py-2 text-sm font-medium text-white
      ${
        isReferencePresent
          ? "bg-red-500"
          : "bg-gray-300 cursor-not-allowed"
      }
    `}
  >
    ✕ Reject
  </button>
</div>


          <button
            onClick={onClose}
            className="w-full rounded-lg border border-gray-300 py-2 text-sm text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BenefitsApprovalModal;
